import React from 'react';
import { hydrateRoot } from 'react-dom/client';

/* third party javascript */
import 'bootstrap';

/* common stylesheets */
import './styles/overrides_bootstrap/bootstrap.scss';
import './styles/font.css';
import './styles/overrides_bootstrap.css';
import './styles/overrides_html.css';
import './styles/index.css';

import App from './App';
import * as serviceWorker from './serviceWorker';

import { HelmetProvider } from 'react-helmet-async';

hydrateRoot(document.getElementById('root'), 
  <HelmetProvider>
    <App />
  </HelmetProvider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
